// extracted by mini-css-extract-plugin
module.exports = {"input":"RouteSpeed_input__2LlHf"};